import React, { useEffect, useState } from 'react';
import "./index.css";
import ImageGallery from "react-image-gallery";
import Card from '@mui/material/Card';
import "react-image-gallery/styles/css/image-gallery.css";
import { ImageService } from '../../services/images/images';
import { ImageGalleryType } from '../../models/imageGallery';
import { Skeleton } from '@mui/material';

interface IProps {
  id: string;
}

function ImageGalleryCard({ id }: IProps) {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [images, setImages] = useState<ImageGalleryType[]>([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const fetchedImages = await ImageService.getGalleryImages(id);
        setImages(fetchedImages);
      } catch (error) {
        console.error(error);
      }
    };
    fetchImages();
  }, [id]);

  const galleryItems = images.map((image) => ({
    ...image,
    originalHeight: isFullScreen ? undefined : 400,
    originalWidth: isFullScreen ? undefined : 600,
  }));

    if (images.length === 0) {
      return (
        <Skeleton
          variant="rectangular"
          width={300}
          height={300}
          sx={{ borderRadius: 2, alignSelf: "center" }}
        />
      );
    }

  return (
    <Card
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        boxShadow: "none",
        width: '100%',
        borderRadius: '12px',
      }}
    >
      <ImageGallery
        items={galleryItems}
        renderItem={(item) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: isFullScreen ? 'auto' : 400,
              overflow: 'hidden',
            }}
          >
            <img
              src={item.original}
              alt={item.originalAlt}
              style={{
                width: isFullScreen ? '100%' : 'auto',
                maxHeight: isFullScreen ? '100%' : 400,
                objectFit: 'cover',
                borderRadius: '12px',
              }}
            />
          </div>
        )}
        showThumbnails={false}
        showIndex
        showBullets
        onScreenChange={setIsFullScreen}
        slideDuration={450}
      />
    </Card>
  );
}

export default ImageGalleryCard;
